import i18n from 'i18next'

/**
 * Locale for dates and times (plan, decision 3.1: only dates/times follow the app
 * language; amounts are always formatted `en-US`). `undefined` in English keeps
 * the device's own date order, as before localization.
 */
export const getDateLocale = (): string | undefined => {
  const language = i18n.isInitialized ? i18n.language : undefined
  if (!language || language === 'en' || language === 'en-XA') return undefined
  return language
}
